import { IcoShield, IcoCompass, IcoOrbit } from './icons';

export const PRODUCTS = [
  {
    id: 'plan',
    name: 'BugZero Plan',
    short: 'Plan',
    tag: 'Upgrade with confidence',
    accent: 'var(--plan)',
    accentSoft: 'var(--plan-soft)',
    accentInk: 'var(--plan-ink)',
    Icon: IcoCompass,
    blurb:
      'Compare upgrade-target versions side-by-side. Review the operational and security risk of each version before you commit.',
    status: 'active',
    rootPath: '/plan'
  },
  {
    id: 'prevent',
    name: 'BugZero Prevent',
    short: 'Prevent',
    tag: 'Detect & remediate',
    accent: 'var(--prevent)',
    accentSoft: 'var(--prevent-soft)',
    accentInk: 'var(--prevent-ink)',
    Icon: IcoShield,
    blurb:
      'Continuously surfaces operational bugs and CVEs across your vendor inventory, routes them to your team, and tracks remediation.',
    status: 'active',
    rootPath: '/prevent'
  },
  {
    id: 'predict',
    name: 'BugZero Predict',
    short: 'Predict',
    tag: 'Anticipate before disclosure',
    accent: 'var(--predict)',
    accentSoft: 'var(--predict-soft)',
    accentInk: 'var(--predict-ink)',
    Icon: IcoOrbit,
    blurb:
      'Models vendor bug feeds to predict which operational defects are likely to become CVEs — so you can act ahead of disclosure.',
    status: 'preview',
    rootPath: '/predict'
  }
];

export const findProduct = id => PRODUCTS.find(p => p.id === id) || PRODUCTS.find(p => p.id === 'prevent');

// Determine which product context the user is in, based on the current URL path.
// Platform = root or any /platform/* path; the launchpad is platform-level.
export const contextFromPath = pathname => {
  if (!pathname || pathname === '/' || pathname.startsWith('/platform')) return 'platform';
  // Support + Documentation are platform-level (shared across products).
  if (pathname.startsWith('/support') || pathname.startsWith('/documentation')) return 'platform';
  if (pathname.startsWith('/plan')) return 'plan';
  if (pathname.startsWith('/predict')) return 'predict';
  return 'prevent';
};

// Per-product tenantSettings flag that gates it. Each product has its own
// dedicated flag; Plan's flag is separate from bsaEnabled (the read-only
// gate consumed by BugScrubTool).
export const PRODUCT_ENABLED_FLAG = {
  plan: 'planEnabled',
  prevent: 'preventEnabled',
  predict: 'predictEnabled'
};

// Is a product enabled for this tenant? Defaults to enabled when the flag
// is absent or settings haven't loaded (fail open — matches default seeds).
export const isProductEnabled = (id, tenantSettings) => {
  const flag = PRODUCT_ENABLED_FLAG[id];
  if (!flag || !tenantSettings) return true;
  return tenantSettings[flag] !== false;
};
